var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper",attrs:{"id":"full-body"}},[_c('LeftSidebar'),_c('div',{staticClass:"main-body"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }